import { AjaxService } from 'Angular/services/core/ajax.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "@angular/forms";
import * as i3 from "../modal-base/components/modal-base.component";
import * as i4 from "../modal-base/components/simple-modal-header.component";
export class ChartEmbedModalComponent {
    constructor(ajaxService) {
        this.ajaxService = ajaxService;
        this.modalOpen = false;
        this.embedCode = 'Loading...';
    }
    openModal() {
        this.modalOpen = true;
        // retrieve code via ajax only when requested
        this.getEmbedCode();
    }
    closeModal() {
        this.modalOpen = false;
    }
    getEmbedCode() {
        this.ajaxService.getJsonP(this.embedCodeUrl).subscribe((rsp) => {
            this.embedCode = rsp;
        });
    }
    selectEmbedCode(event) {
        event.currentTarget.select();
    }
    copyEmbedCode() {
        const input = document.querySelector('#embedCode');
        if (input) {
            input.select();
            navigator.clipboard.writeText(input.value).then(() => { });
        }
    }
}
ChartEmbedModalComponent.ɵfac = function ChartEmbedModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartEmbedModalComponent)(i0.ɵɵdirectiveInject(i1.AjaxService)); };
ChartEmbedModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChartEmbedModalComponent, selectors: [["ycn-chart-embed-modal"]], inputs: { embedCodeUrl: "embedCodeUrl" }, standalone: false, decls: 14, vars: 2, consts: [[3, "closeModalHandler", "open"], ["header", "Embed Chart View", 3, "closeModalHandler"], [1, "modal-body"], [1, "modal-section"], [1, "form-row"], [1, "form-label"], [1, "input-group"], [1, "field-input-group", "input-group"], ["id", "embedCode", 1, "form-control", 3, "ngModelChange", "click", "ngModel"], [1, "input-group-btn"], [1, "btn", "btn-secondary", 3, "click"], [1, "modal-footer"]], template: function ChartEmbedModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function ChartEmbedModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function ChartEmbedModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5);
        i0.ɵɵtext(6, " Copy the embed code below and paste into your intended destination. ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6)(8, "div", 7)(9, "input", 8);
        i0.ɵɵtwoWayListener("ngModelChange", function ChartEmbedModalComponent_Template_input_ngModelChange_9_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.embedCode, $event) || (ctx.embedCode = $event); return $event; });
        i0.ɵɵlistener("click", function ChartEmbedModalComponent_Template_input_click_9_listener($event) { return ctx.selectEmbedCode($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "span", 9)(11, "div", 10);
        i0.ɵɵlistener("click", function ChartEmbedModalComponent_Template_div_click_11_listener() { return ctx.copyEmbedCode(); });
        i0.ɵɵtext(12, " Copy ");
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelement(13, "div", 11);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen);
        i0.ɵɵadvance(9);
        i0.ɵɵtwoWayProperty("ngModel", ctx.embedCode);
    } }, dependencies: [i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, i3.ModalBaseComponent, i4.SimpleModalHeaderComponent], encapsulation: 2 });
